import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import useSubmitButtonProps from '../../../../_partials/SubmitButton/useSubmitButtonProps';
import { DailyChallengeArray } from '../types';

import s from './SelectedDailyChallengeHeading.scss';

export interface Props {
  tag: string;
  dailyChallenges: DailyChallengeArray;
  className?: string;
}

// todo maybe we don't need the full challenge? just tag and isToday?
const SelectedDailyChallengeHeading: React.FC<Props> = ({
  tag,
  dailyChallenges,
  className,
}) => {
  const { t } = useTranslation();
  const submitButtonProps = useSubmitButtonProps({
    tags: tag,
    biSectionname: 'tags',
  });

  if (!tag || !Array.isArray(dailyChallenges)) {
    return null;
  }

  // we don't have anything from them to tell -which- challenge matched the current tag
  const { today } =
    dailyChallenges.find(challenge => challenge.tag.tag === tag) || {};

  return (
    <Section className={classnames(className, s['root'])}>
      <Heading className={s['current-tag']}>{`#${tag}`}</Heading>

      <p className={s['challenge-text']}>
        {t('tagPage.dailyChallenge.challengeText', {
          specifier: t(
            today
              ? 'tagPage.dailyChallenge.challengeText.themeSpecifier.today'
              : 'tagPage.dailyChallenge.challengeText.themeSpecifier.notToday'
          ),
        })}
      </p>

      <SolidButton
        className={s['submit-button']}
        variant="approval-green"
        size="large"
        {...submitButtonProps}
      >
        {t('tagPage.dailyChallenge.submitTo', { tag })}
      </SolidButton>
    </Section>
  );
};
SelectedDailyChallengeHeading.displayName = 'SelectedDailyChallengeHeading';

export default SelectedDailyChallengeHeading;
